import React from "react";
import ReactDOM from "react-dom";

const ModalVideo = ({ videos, onClose }) => {

  if (!videos || videos.length === 0) return null;

  const videoUrl = videos[0].replace("watch?v=", "embed/").split("&")[0];

  const modalContent = (
    <div className="video-overlay" onClick={onClose}>
      <div className="video-modal video-modal-animate" onClick={(e) => e.stopPropagation()}>

        <button className="video-close" onClick={onClose}>
          ✕
        </button>

        <div className="video-container">
          <iframe
            src={videoUrl}
            title="Video ejemplo"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </div>

      </div>
    </div>
  );

  return ReactDOM.createPortal(
    modalContent,
    document.getElementById("modal-root")
  );
};

export default ModalVideo;